export default function LinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6.34795 11.6509L11.6512 6.34757M10.3253 12.9773L8.11555 15.187C7.41225 15.8901 6.45849 16.285 5.46403 16.2849C4.46958 16.2848 3.51589 15.8897 2.8127 15.1865C2.10952 14.4834 1.71444 13.5297 1.71436 12.5352C1.71427 11.5408 2.10919 10.587 2.81225 9.88369L5.02196 7.67399M12.9773 10.3253L15.187 8.11555C15.8901 7.41225 16.285 6.45849 16.2849 5.46403C16.2848 4.46958 15.8897 3.51589 15.1865 2.81271C14.4834 2.10952 13.5297 1.71444 12.5352 1.71436C11.5408 1.71427 10.587 2.10919 9.8837 2.81225L7.67399 5.02196"
        stroke="#5E718D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
